import React from "react";

import { getFieldName } from "helpers/myLivestock";

import { LoadingOverlay, InputSelect } from "components";

import { useFieldNamesQuery } from "generated/graphql";

import styles from "./BusinessUnitFieldSelect.module.scss";
import { getBUFromLocalStorage } from "helpers/storage";
import { removeNothings } from "helpers/general";

interface Props {
  value: string;
  onSelect: (value: string) => void;
}

export const BusinessUnitFieldSelect: React.FC<Props> = ({ value, onSelect }) => {
  const { data: fieldsData, loading } = useFieldNamesQuery({
    variables: {
      businessUnitId: getBUFromLocalStorage(),
    },
    fetchPolicy: "cache-and-network",
    nextFetchPolicy: "cache-only",
  });

  const fields = removeNothings(fieldsData?.fields || []);

  const isLoading = loading && fields.length === 0;

  const handleSelectChange = (e): void => {
    e.stopPropagation();

    onSelect(e.target.value);
  };

  const options = fields.map((item) => {
    const label = getFieldName({ fieldName: item.name, unitName: item.location?.unitName });

    return {
      key: item.id,
      value: item.id,
      label,
    };
  });

  return isLoading ? (
    <div style={{ position: "relative", height: "100px" }}>
      <LoadingOverlay customStyles={styles.loadingOverlay} />
    </div>
  ) : (
    <InputSelect
      name="bu-field"
      value={value}
      options={options}
      onChange={handleSelectChange}
      placeholder="select location"
      data-testid="move-bu-to-field-select"
      data-testvalue={fields.length}
    />
  );
};
